import { setMode } from '@stencil/core';

export default async () => {
  /**
   * The code to be executed should be placed within a default function that is
   * exported by the global script. Ensure all of the code in the global script
   * is wrapped in the function() that is exported.
   */
};

// Element with Property "mode"
setMode(customElement => {
	const element: any = customElement as any;

	if (!element.mode) element.setAttribute('mode', 'default');

	return element.mode;
});
